import { forwardRef, type SVGProps } from "react";

/**
 * Compact rendering of the Swiss flag, used in the header/footer/hero
 * trust signals. SVG (not emoji) so it renders identically across
 * browsers and OSes — emoji 🇨🇭 falls back to thin Windows glyphs.
 *
 * Constant colors (red + white) — does not inherit currentColor.
 * Inscribed by default in a rounded square; pass `square` for a hard square.
 */
export const SwissFlag = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & { square?: boolean }>(
  function SwissFlag({ className, square = false, ...props }, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className={className}
        {...props}
      >
        <rect
          width="32"
          height="32"
          rx={square ? 0 : 4}
          fill="hsl(var(--swiss-red))"
        />
        <rect x="13" y="6" width="6" height="20" fill="#ffffff" />
        <rect x="6" y="13" width="20" height="6" fill="#ffffff" />
      </svg>
    );
  }
);
